import { getPopupActionsFor } from '@/scheduling/lib/appointment-actions';
import type { AppointmentResponse } from '@/types/scheduling-api';

export function isToday(startISO?: string): boolean {
  if (!startISO) return false;
  const start = new Date(startISO);
  const now = new Date();
  return (
    start.getFullYear() === now.getFullYear() &&
    start.getMonth() === now.getMonth() &&
    start.getDate() === now.getDate()
  );
}

/** Whether the popup's rule set offers Cancel for this appointment (the header Cancel uses the same rule the footer did). */
export function popupOffersCancel(appt: AppointmentResponse): boolean {
  return getPopupActionsFor({
    statusCode: appt.status?.code ?? '',
    isToday: isToday(appt.start),
    isHomeLocation: (appt.location?.name ?? '').toLowerCase() === 'home',
    isRecurring: !!appt.recurring?.id,
  }).some((a) => a.id === 'cancel');
}
